import { render, staticRenderFns } from "./DataTableSb.vue?vue&type=template&id=18b0c679&scoped=true"
import script from "./DataTableSb.vue?vue&type=script&lang=js"
export * from "./DataTableSb.vue?vue&type=script&lang=js"
import style0 from "./DataTableSb.vue?vue&type=style&index=0&id=18b0c679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0c679",
  null
  
)

export default component.exports